var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.26699,
    y: 0.6,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint0_linear_706_71229)",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.26699,
    y: 0.6,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint1_linear_706_71229)",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8666,
    y: 10.1996,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint2_linear_706_71229)",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8666,
    y: 10.1996,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint3_linear_706_71229)",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_71229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.496 39.6789L31.5519 38.6127L30.4832 41.6661L30.119 40.564C30.0374 40.3173 29.8439 40.1238 29.5972 40.0424L28.496 39.6789ZM37.3982 40.1616C37.3982 44.2084 34.1027 47.5006 30.052 47.5006C26.0013 47.5006 22.7041 44.2083 22.7041 40.1616C22.7041 36.1149 26.0003 32.8242 30.052 32.8242C34.1036 32.8242 37.3982 36.1157 37.3982 40.1616ZM33.4687 36.6979C33.2461 36.475 32.9156 36.3994 32.6181 36.5031L25.674 38.9259C25.3422 39.0417 25.121 39.3559 25.1239 39.7073C25.1269 40.0588 25.3534 40.3693 25.6871 40.4794L28.6909 41.4709L29.682 44.4704C29.7922 44.8039 30.1025 45.0302 30.4537 45.0333H30.4609C30.8092 45.0333 31.1199 44.8132 31.2351 44.484L33.6627 37.5487C33.7667 37.2513 33.6914 36.9207 33.4687 36.6979H33.4687ZM41.4782 45.8343V26.4373L35.9694 24.0226V33.4105C37.8496 35.0573 39.0389 37.4732 39.0389 40.1616C39.0389 41.66 38.6691 43.0736 38.0168 44.3168L41.4782 45.8343ZM30.052 31.1836C31.5992 31.1836 33.0563 31.5762 34.3288 32.267V24.0227L27.8475 26.8642C27.7083 26.9252 27.6184 27.0628 27.6184 27.2148V31.5182C28.3927 31.3004 29.2089 31.1836 30.052 31.1836ZM49.6557 23.7606C49.5475 23.6899 49.4109 23.6786 49.2926 23.7304L43.1188 26.4372V45.8343L49.6 42.9927C49.7391 42.9317 49.829 42.7941 49.829 42.6421V24.0811C49.829 23.9518 49.7639 23.8313 49.6556 23.7606H49.6557Z",
    fill: "#009DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_71229",
    x1: 6.52797,
    y1: 75.1073,
    x2: 75.1231,
    y2: -4.77561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_71229",
    x1: 71.6499,
    y1: -9.11707,
    x2: 6.52797,
    y2: 71.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_706_71229",
    x1: 4.60531,
    y1: 12.5351,
    x2: 62.0569,
    y2: 61.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_71229",
    x1: 72.5408,
    y1: 73.3415,
    x2: 12.1537,
    y2: 30.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_71229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(22.2666 21.5996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutemap);
export default __webpack_public_path__ + "static/media/Routemap.a2e2cd00f20c59928b1044be387df119.svg";
export { ForwardRef as ReactComponent };